import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAttractionsDetails } from "../attractionsModal";

export const getAllAttractions = createAsyncThunk(
  "Attraction/FindAllAttraction",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/FindAllAttraction`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Attractions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createAttractions = createAsyncThunk(
  "Attraction/InsertAttraction",
  async (AttractionsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/InsertAttraction`,
        AttractionsData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Attractions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateAttractions = createAsyncThunk(
  "Attraction/UpdateAttraction",
  async (AttractionsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/UpdateAttraction`,
        AttractionsData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Attractions :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteAttractions = createAsyncThunk(
  "Attraction/DeleteAttraction",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/DeleteAttraction`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Attractions :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteAttractionsImage = createAsyncThunk(
  "Attraction/DeleteAttractionImages",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/DeleteAttractionImages`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Attractions image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAttractionsByID = createAsyncThunk(
  "Attraction/FindByIDAttraction",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/FindByIDAttraction`,
        { ID },
      );
      const result = response.data?.Data;
      return {
        ID: result?.ID,
        Title: result?.Title,
        AttractionURL: result?.AttractionURL,
        AttractionCategory: result?.AttractionCategory,
        TagLine: result?.TagLine,
        Distance: result?.Distance,
        TravelTime: result?.TravelTime,
        BestTime: result?.BestTime,
        Duration: result?.Duration,
        Description: result?.Description,
        Dos: result?.Dos,
        Donts: result?.Donts,
        IsMustVisit: result?.IsMustVisit || false,
        MainImage: result?.MainImage,
        BannerImage: result?.BannerImage,
        MetaTitle: result?.MetaTitle,
        MetaDescription: result?.MetaDescription,
        MetaKeywords: result?.MetaKeywords,
        IsActive: result?.IsActive ? 1 : 2,
        BestTimes: result?.BestTimes ?? [],
        HowToReach: result?.HowToReach ?? [],
        ThingsToDo: result?.ThingsToDo ?? [],
        WhyVisit: result?.WhyVisit ?? [],
        Nearby: result?.Nearby ?? [],
        Images: result?.Images ?? [],
      } as IAttractionsDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Attractions :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAttractionsByURL = createAsyncThunk(
  "Attraction/AttractionFindByURL",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/AttractionFindByURL`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        AttractionURL: result.AttractionURL,
        AttractionCategory: result.AttractionCategory,
        TagLine: result.TagLine,
        Distance: result.Distance,
        TravelTime: result.TravelTime,
        BestTime: result.BestTime,
        Duration: result.Duration,
        Description: result.Description,
        Dos: result.Dos,
        Donts: result.Donts,
        MainImage: result.MainImage,
        BannerImage: result.BannerImage,
        MetaTitle: result.MetaTitle,
        MetaDescription: result.MetaDescription,
        MetaKeywords: result.MetaKeywords,
        IsMustVisit: result?.IsMustVisit,
        IsActive: result.IsActive ? 1 : 2,
        BestTimes: result.BestTimes ?? [],
        HowToReach: result.HowToReach ?? [],
        ThingsToDo: result.ThingsToDo ?? [],
        WhyVisit: result.WhyVisit ?? [],
        Nearby: result?.Nearby ?? [],
        Images: result?.Images ?? [],
      } as IAttractionsDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Attractions :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveAttractions = createAsyncThunk(
  "Attraction/FindAllActiveAttraction",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Attraction/FindAllActiveAttraction`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Attractions:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveAttractions = createAsyncThunk(
  "Attraction/ActiveInActiveAttraction",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/ActiveInActiveAttraction`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Attractions :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const AttractionsImageUpload = createAsyncThunk(
  "Attraction/AttractionImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Attraction/AttractionImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Attractions Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
